import {
    Button,
    IconButton,
    Tooltip,
    Typography
} from "@material-ui/core";
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { FlagEntityTypes } from "features/flag/flagsConsts";
import { useGetLatestFlagQuery } from "features/flag/flagsSlice";
import { IconFlag, IconRedFlag } from "icons";
import { useState } from "react";
import { FlagAssetDialog } from "./FlagAssetDialog";
import { FlagTooltip } from "./FlagTooltip";
import { bulkActionsStyle } from "./style";

export const FlagAsset = ({
    selectedRows,//injected by the bulkActions
    allData,
    addFlag,
    getFlagFromApi = true,
    flagOn,
    entityType,
    iconOnly,
    iconClassName,
    readonly = !isAuthorized(permissionProfiles.FLAGS.EDIT_FLAGS),
    sourceType,
    flagObj
}) => {

    let { data: flagFromApi, error: flagsError, isFetching: isLoadingflags } = useGetLatestFlagQuery({ entityIds: selectedRows, entityType: entityType }, { skip: !getFlagFromApi || !selectedRows.join(',') });

    const flagObject = flagObj ?? flagFromApi;
    sourceType = flagFromApi?.sourceType ?? sourceType;

    const classes = bulkActionsStyle();
    const [open, setOpen] = useState(false);

    const isFlagOn = flagFromApi || flagOn;
    const canSeeFlags = isAuthorized(permissionProfiles.FLAGS.VIEW_FLAGS);

    const textByType = {
        [FlagEntityTypes.ASSET]: selectedRows?.length > 1 ? 'Assets' : 'Asset',
        [FlagEntityTypes.ACTIVITY]: selectedRows?.length > 1 ? 'Activities' : 'Activity',
        [FlagEntityTypes.TRANSPORT]: selectedRows?.length > 1 ? 'Loads' : 'Load',
        [FlagEntityTypes.ISSUE_TRACKER]: selectedRows?.length > 1 ? 'Tickets' : 'Ticket',
        [FlagEntityTypes.RESERVATION]: selectedRows?.length > 1 ? 'Reservations' : 'Reservation',
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const onOpenPopover = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const closePopover = (e) => {
        setAnchorEl();
    }

    const openPopover = Boolean(anchorEl);

    const onOpen = () => {
        setOpen(true);
    }

    const showFlagButton = canSeeFlags && (!readonly || (readonly && isFlagOn) || iconOnly);

    return (
        <>
            {showFlagButton && (
                isFlagOn ? (
                    <Typography
                        aria-owns={openPopover ? 'mouse-over-popover' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={onOpenPopover}
                        onMouseLeave={closePopover}
                    >
                        <FlagTooltip
                            anchorEl={anchorEl}
                            closePopover={closePopover}
                            sourceType={sourceType}
                            entityType={entityType}
                            flagObj={flagObject}
                        />
                        <IconButton onClick={!readonly && onOpen} disabled={readonly}>
                            <IconRedFlag />
                        </IconButton>
                    </Typography>
                ) : (
                    iconOnly ? (
                        <div className={iconOnly && !readonly && classes.flagOffIconContainer}>
                            <Tooltip title={`Flag ${textByType[entityType]}`}>
                                <IconButton className={iconOnly ? classes.flagOffIcon : iconClassName} onClick={!readonly && onOpen} disabled={readonly}>
                                    <IconFlag />
                                </IconButton>
                            </Tooltip>
                        </div>
                    ) : (
                        <Button onClick={!readonly && onOpen} disabled={readonly} className={classes.button}>
                            <div>
                                <div>
                                    <IconFlag />
                                </div>
                                <div>
                                    {`Flag ${textByType[entityType]}`}
                                </div>
                            </div>
                        </Button>
                    )
                )
            )}
            {open && <FlagAssetDialog
                setOpen={setOpen}
                open={open}
                selectedRows={selectedRows}
                allData={allData}
                addFlag={addFlag}
                flagOn={isFlagOn}
                entityType={entityType}
                sourceType={sourceType}
            />}
        </>
    );
}